export const MOBILE_BREAKPOINT = 'sm';
